import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M17 3.34a10 10 0 1 1 -15 8.66l.005 -.324a10 10 0 0 1 14.995 -8.336m-6 12.16a1 1 0 0 0 2 0v-8.5a1 1 0 0 0 -2 0z","key":"svg-0"}]]

const IconClockHour6Filled = createReactComponent('filled', 'clock-hour-6-filled', 'ClockHour6Filled', __iconNode);

export default IconClockHour6Filled;